import { Link, useNavigate } from 'react-router-dom';
import { Button, Paper, Typography } from '@mui/material';
import { useIdentity } from 'context/identity-provider';
import styles from './portal-view.module.scss';

// Placeholder admin portal landing page — proves the auth loop end to end.
// Nothing sensitive may ever be compiled into this component: the bundle is public.
const PortalView: React.FC = () => {
  const { email, expiresAt, signOut } = useIdentity();
  const navigate = useNavigate();

  const signOutHandler = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className={styles.portalRoot}>
      <header className={styles.header}>
        <Typography variant="h6" component="h1">Admin Portal</Typography>
        <div className={styles.headerRight}>
          <span className={styles.email}>{email}</span>
          <Link to="/" className={styles.link}>site</Link>
          <Button size="small" variant="outlined" onClick={signOutHandler}>Sign out</Button>
        </div>
      </header>

      <main className={styles.main}>
        <Paper className={styles.card}>
          <Typography variant="h5" gutterBottom>Under construction</Typography>
          <Typography color="text.secondary">
            Personal finance &amp; trading sandbox. Tools will land here.
          </Typography>
          {process.env.NODE_ENV === 'development' && expiresAt && (
            <Typography variant="caption" component="p" className={styles.devInfo}>
              [dev] ID token expires {new Date(expiresAt).toLocaleTimeString()}
            </Typography>
          )}
        </Paper>
      </main>
    </div>
  );
};

export default PortalView;
